export default {
    API_PREFIX: 'https://candidate.lenreg.ru/api/',
    IS_PREFIX: 'https://auth.lenreg.ru/',
    FE_PREFIX: 'https://candidate.lenreg.ru',
    VENDOR_WEBSITE: 'http://www.alekoncenter.ru',
    VERSION: '1.6 от 15.12.2021',
    WELCOME_URL: '/',
    LEGAL_ACT_URL: '/legalact/',
    LEGAL_ACTS_URL: '/legalacts',
    VACANCY_URL: '/vacancy',
    DOC_VIEWER_URL: '/docviewer',
    RESUME_URL: '/resume',
    NOTIFICATIONS_URL: '/notifications',
    SCENARIO_WELCOME_URL: '/scenario-welcome',
    NOT_FOUND_URL: '/notfound',
    FORBIDDEN_URL: '/forbidden',
    INTERNAL_SERVER_ERROR_URL: '/internalservererror',
    NOT_AUTHORIZED_URL: '/notauthorized',
    APP_NAME: 'АК Конкурс-кадры',
    CLIENT_ID: 'hrc-main'
}



// WEBPACK FOOTER //
// ./src/appsettings.js